import { clsx } from 'clsx';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/outline';

interface CarouselButtonProps {
  direction: 'previous' | 'next';
  onClick: () => void;
  show: boolean;
}

export const CarouselButton = ({
  direction,
  onClick,
  show,
}: CarouselButtonProps) => {
  const Icon = direction === 'next' ? ChevronRightIcon : ChevronLeftIcon;

  return (
    <>
      <div
        aria-hidden="true"
        className={clsx(
          'pointer-events-none absolute inset-y-0 w-20 from-white to-transparent transition-opacity',
          direction === 'next'
            ? 'right-[28px] bg-gradient-to-l'
            : 'left-[28px] bg-gradient-to-r',
          show ? 'opacity-100' : 'opacity-0',
        )}
      />
      <button
        type="button"
        className={clsx(
          'absolute top-1/2 flex size-6 -translate-y-1/2 items-center justify-center rounded-full bg-transparent text-gray-500 outline-none hover:text-teal-800 focus-visible:ring-2 focus-visible:ring-teal-600',
          direction === 'next' ? 'right-1' : 'left-1',
          show ? 'block' : 'hidden',
        )}
        aria-label={`See ${direction} locations`}
        onClick={onClick}
      >
        <Icon className="size-4 " />
      </button>
    </>
  );
};
